/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_GithubInputs */

const en_fc_footer_github = /** @type {(inputs: Fc_Footer_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source code (GitHub)`)
};

/**
* | output |
* | --- |
* | "Source code (GitHub)" |
*
* @param {Fc_Footer_GithubInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_github = /** @type {((inputs?: Fc_Footer_GithubInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_GithubInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_github(inputs)
});
export { fc_footer_github as "fc.footer.github" }